import { globalRequest } from '@/api/axios'

export const zoneOs4ManualTestApi = <T = any>(
  zoneId: number | string
): Promise<T> => {
  const config = {
    url: `/zone/getZoneTmpById/${zoneId}`
  }
  return globalRequest.request<T>(config)
}
